export default __webpack_public_path__ + "static/media/IMG_0285.f27d1580.JPG";